import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

$(function () {
    $('.promo-banner').each(function () {
        const $banner = $(this);
        const slidesCount = $banner.find('.swiper-slide').length;

        $('body').addClass('has-promo');

        const swiper = new Swiper(this, {
            modules: [Navigation, Pagination, Autoplay],
            slidesPerView: 1,
            loop: slidesCount > 1,
            pagination: slidesCount > 1 ? {
                el: $banner.find('.swiper-pagination')[0],
                clickable: true,
                type: 'fraction',
            } : false,
            navigation: slidesCount > 1 ? {
                nextEl: $banner.find('.swiper-button-next')[0],
                prevEl: $banner.find('.swiper-button-prev')[0],
            } : false,
            autoplay: slidesCount > 1 ? {
                delay: 2500,
                disableOnInteraction: false
            } : false
        });

        if (slidesCount > 1) {
            let isPlaying = true;
            const $toggle = $banner.find('.autoplay-toggle');
            const $iconPlay = $banner.find('.icon-play');
            const $iconPause = $banner.find('.icon-pause');

            $toggle.on('click', function () {
                if (isPlaying) {
                    swiper.autoplay.stop();
                    $(this).attr('aria-label', 'Play');
                    $iconPause.addClass('d-none');
                    $iconPlay.removeClass('d-none');
                } else {
                    swiper.autoplay.start();
                    $(this).attr('aria-label', 'Pause');
                    $iconPlay.addClass('d-none');
                    $iconPause.removeClass('d-none');
                }
                isPlaying = !isPlaying;
            });
        } else {
            $banner.find('.promo-banner__pager').remove();
            $banner.find('.promo-banner__autoplay').remove();
            $banner.find('.swiper-wrapper').addClass('one-text');

        }
    });
});